import { vars } from '../../theme';
import React from 'react';
import HBBannerBase from '../HBBanner/HBBannerBase';
import { ExclamationMarkCircle24 } from '@honeybook/icons';
import { HBBannerProps } from '../HBBanner/HBBanner.types';
import { MustIncludeOneOfBasicTestIdProps } from '../common/internal/test-id.types';

export interface Props extends HBBannerProps {
    /** HBButton theme for the primary action. 'secondary-solid-secondary' for a filled secondary button; 'button-link' for a link-style action. */
    primaryActionTheme?: 'secondary-solid-secondary' | 'button-link';
}

const WarningBanner = (props: Props & MustIncludeOneOfBasicTestIdProps) => {
    return (
        <HBBannerBase
            icon={ExclamationMarkCircle24}
            primaryActionTheme="secondary-solid-secondary"
            {...props}
            accentLine={vars.colors.base.warning}
            background={vars.colors.surface.warning}
        />
    );
};

export default WarningBanner;
